/**
 *
 * Hamburger
 *
 */

import { Component } from "react";
import styled from "styled-components";
import { Menu, MenuItem } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { styling } from "styling";
import GlobalMessages from "messages/messages";
import { getBearer, hasRole, removeUser, ROLES } from "utils/userStorage";
import history from "utils/history";
import { removePractice } from "utils/practiceStorage";
import * as PropTypes from "prop-types";
import messages from "./messages";

class Hamburger extends Component {
  static propTypes = {
    filter: PropTypes.arrayOf(PropTypes.string),
    selectPractice: PropTypes.func,
    isAdminPage: PropTypes.bool,
  };

  state = {
    anchorEl: null,
  };

  isOpen() {
    return !!this.state.anchorEl;
  }

  handleHamburgerClicked = e => {
    this.setState({
      anchorEl: e.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleAdminPage = () => {
    history.push("/admin");
  };

  handleEditUser = () => {
    history.push("/dashboard/practice");
  };

  handlePractice = () => {
    this.props.selectPractice(null);
    removePractice();
    history.push("/practice");
  };

  handleLogout = () => {
    fetch(`${__URLS__["api"]}admin/Logout`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getBearer()}`,
      }
    }).then(res => res.text()).then(() => {
      localStorage.removeItem('jwt')
      this.props.selectPractice(null);
      removePractice();
      removeUser();
      history.push("/login");
    })
  };

  shouldRender(item) {
    if (item === "adminPage") {
      if (
        this.props.isAdminPage ||
        !hasRole([ROLES.KPT, ROLES.CS, ROLES.Sales, ROLES.Admin])
      ) {
        return false;
      }
    }

    if (!this.props.filter) {
      return true;
    }

    return this.props.filter.includes(item);
  }

  render() {
    const { isAdminPage } = this.props;
    return (
      <>
        <Box onClick={this.handleHamburgerClicked} id="HamburgerMenu">
          <Line color={styling.blue} />
          <Line color={styling.orange} />
          <Line color={styling.green} />
        </Box>
        <Menu
          id="menu-appbar"
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={this.isOpen()}
          onClose={this.handleClose}
        >
          {this.shouldRender("practice") && (
            <MenuItem
              onClick={isAdminPage ? this.handlePractice : this.handleEditUser}
              id="practice-menu-item"
            >
              <FormattedMessage {...messages.practice} />
            </MenuItem>
          )}
          {this.shouldRender("adminPage") && (
            <MenuItem onClick={this.handleAdminPage} id="admin-page-menu-item">
              <FormattedMessage {...messages.adminPage} />
            </MenuItem>
          )}
          {this.shouldRender("logout") && (
            <MenuItem
              onClick={this.handleLogout}
              id="logout-menu-item"
              data-cy="logout"
            >
              <FormattedMessage {...GlobalMessages.logout} />
            </MenuItem>
          )}
        </Menu>
      </>
    );
  }
}

const Line = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ color }) => color};
`;

const Box = styled.div`
  cursor: pointer;
  margin-left: ${({ theme }) => theme.margin}rem;
  //margin-top: 0.5rem;
  width: 1.5rem;
  margin-top: 5px;
  margin-bottom: 5px;
  height: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export default Hamburger;
